import React from "react";
import "../css/main.css";
import "../css/responsive.css";
import messenger from "../images/facebook-white.png";
import instagram from "../images/InstagramLogo.png";
import x from "../images/XLogo.png";
import telegram from "../images/TelegramLogo.png";
import paperplane from "../images/PaperPlaneTilt.png";
import Logo from "../components/Logo";

const Footer = () => {
  return (
    <div>
      <footer>
        <div className="container">
          <div className="footer-top">
            <div className="logo">
              <Logo />
            </div>
            <div className="socials">
              <div className="social phone-number">
                <label>Follow Us On:</label>
              </div>
              <div className="social messenger">
                <a
                  href="https://www.facebook.com/theorlov.centrudepsihoterapie?mibextid=wwXIfr&rdid=eNrpX1Vzl3sruERT&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1PjfTfw4zM%2F%3Fmibextid%3DwwXIfr#"
                  className="icon"
                >
                  <img alt="footer-icon" src={messenger} />
                </a>
              </div>
              <div className="social instagram">
                <a
                  href="https://www.instagram.com/_theorlov_/?igsh=dnd0NHl6dmw3b3l2&utm_source=qr#"
                  className="icon"
                >
                  <img alt="footer-icon" src={instagram} />
                </a>
              </div>
            </div>
          </div>
          <div className="main-footer">
            <div className="grid-4">
              <div className="column">
                <h3>Aware</h3>
                <a href="/evenimente">Evenimente</a>
                <a href="/despre-noi">Despre noi</a>
                <a href="/servicii">Servicii</a>
                <a href="/contact">Contact</a>
                <a href="/under-construction">Echipa noastra</a>
              </div>
              <div className="column">
                <h3>Serviciile noastre</h3>
                <a href="/servicii">Terapie Individuală</a>
                <a href="/servicii">Terapie de Cuplu & Relații</a>
                <a href="/servicii">Terapie de Familie & Parenting</a>
                <a href="/servicii">Terapie pentru Anxietate și Depresie</a>
                <a href="/servicii">Child & Adolescent Therapy</a>
              </div>
              <div className="column">
                <h3>Terapeuții Noștri</h3>
                <a href="/under-construction">Annette Black</a>
                <a href="/under-construction">Jane Cooper</a>
                <a href="/under-construction">Brooklyn Simmons</a>
                <a href="/under-construction">Kathryn Murphy</a>
                <a href="/under-construction">Cameron Williamson</a>
              </div>
              <div className="column">
                <h3>Abonează-te la Newsletter</h3>
                <div className="newsletter-footer">
                  <div className="input-container">
                    <input type="email" placeholder="Email" />
                    <div class="submit-button">
                      <input
                        type="submit"
                        className="button primary"
                        value=""
                      />
                      <img alt="footer-icon" src={paperplane} />
                    </div>
                  </div>
                </div>
                <p>
                  Te rugăm să te abonezi pentru a urmări cele mai recente
                  evenimente de la noi, promitem că nu îți vom trimite spam.
                </p>
              </div>
            </div>
          </div>
          <div className="copyright">
            <p>Copyright © 2025 Aware. Toate drepturile rezervate.</p>
            <div className="links">
              <a href="/conditii">Termeni și Condiții</a>
              <a href="/confidentialitate">Politica de confidentialitate</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
